import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

const CountDownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    return difference > 0
      ? {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / (1000 * 60)) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        }
      : { days: 0, hours: 0, minutes: 0, seconds: 0 };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
        gap: { md: "20px", xs: "8px" },
        mt: 3,
        overflowX: "auto",
      }}
    >
      {timeLeft &&
        ["days", "hours", "minutes", "seconds"].map((unit) => (
          <Box
            key={unit}
            sx={{
              width: { md: "100px", xs: "60px" },
              height: { md: "100px", xs: "60px" },
              borderRadius: "12px",
              background:
                unit === "seconds"
                  ? "#FFD54F" // Warm golden yellow
                  : unit === "minutes"
                    ? "#4FC3F7" // Light blue
                    : unit === "hours"
                      ? "#FF8A65" // Soft coral
                      : "#81C784", // Pastel green for days
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              p: { md: 2, xs: 1 },
            }}
          >
            <Typography
              sx={{
                color: "#3E2723", // Deep brown for contrast
                fontFamily: "Roboto",
                fontSize: { md: "40px", xs: "20px" },
                lineHeight: "1",
                fontWeight: "bold",
              }}
            >
              {timeLeft[unit]}
            </Typography>
            <Typography
              sx={{
                color: "#5D4037", // Warm brown for labels
                fontFamily: "Roboto",
                fontSize: { md: "16px", xs: "10px" },
                lineHeight: "1",
                fontWeight: "medium",
                mt: 1,
              }}
            >
              {unit.charAt(0).toUpperCase() + unit.slice(1)}
            </Typography>
          </Box>
        ))}
    </Box>
  );
};

export default CountDownTimer;
